import * as React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

// Gabarit commun aux pages légales (mentions légales, confidentialité).
// Pages autonomes à leur propre URL — crawlables par les moteurs et les bots IA.
export function LegalPageLayout({ title, children }: { title: string; children: React.ReactNode }) {
  React.useEffect(() => {
    window.scrollTo(0, 0)
    document.title = `${title} — Lorenz Campan`
  }, [title])

  return (
    <div className="min-h-screen bg-surface text-white">
      <div className="container mx-auto px-6 max-w-3xl py-16 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-white/50 hover:text-white transition-colors text-sm mb-10"
        >
          <ArrowLeft size={16} />
          Retour à l'accueil
        </Link>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-10">{title}</h1>
        <div className="text-white/70 space-y-6 prose prose-invert max-w-none">{children}</div>
      </div>
    </div>
  )
}
